var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9647 9.7671L16.7459 13.4074L18.0313 18.8515C18.1022 19.147 18.0839 19.4569 17.9788 19.7421C17.8736 20.0272 17.6864 20.2748 17.4406 20.4536C17.1948 20.6324 16.9015 20.7343 16.5979 20.7465C16.2942 20.7587 15.9937 20.6806 15.7344 20.5221L11 17.6083L6.26282 20.5221C6.00353 20.6797 5.70341 20.757 5.40026 20.7444C5.0971 20.7318 4.80446 20.6297 4.55919 20.4511C4.31392 20.2725 4.12698 20.0253 4.02191 19.7406C3.91685 19.456 3.89835 19.1466 3.96875 18.8515L5.25875 13.4074L1.04 9.7671C0.810594 9.56882 0.644682 9.30736 0.562986 9.01536C0.48129 8.72336 0.487431 8.41376 0.580642 8.12522C0.673852 7.83669 0.850002 7.58201 1.08709 7.39299C1.32418 7.20397 1.6117 7.08899 1.91375 7.06241L7.445 6.61616L9.57875 1.45241C9.69425 1.17099 9.89082 0.930267 10.1435 0.760851C10.3961 0.591435 10.6935 0.500977 10.9977 0.500977C11.3019 0.500977 11.5992 0.591435 11.8518 0.760851C12.1045 0.930267 12.3011 1.17099 12.4166 1.45241L14.5494 6.61616L20.0806 7.06241C20.3833 7.088 20.6716 7.20234 20.9096 7.3911C21.1475 7.57986 21.3245 7.83464 21.4183 8.12352C21.5121 8.41241 21.5185 8.72254 21.4368 9.01508C21.3552 9.30761 21.189 9.56954 20.9591 9.76803L20.9647 9.7671Z",
    fill: "#F9D34B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStarIcon);
export default __webpack_public_path__ + "static/media/filled-star-icon.aeab558b331962e292e79e1919f55f07.svg";
export { ForwardRef as ReactComponent };